<template>
  <div class="my-Video">
    <div class="my_video">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      >
      </video-player>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // playerOptions: {
      //     playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
      //     autoplay: false, //如果true,浏览器准备好时开始回放。
      //     muted: false, // 默认情况下将会消除任何音频。
      //     loop: true, // 视频一结束就重新开始。
      //     preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //     language: 'zh-CN',
      //     aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //     fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      //     sources: [{
      //         type: "video/mp4", // 类型
      //         src: require('../../static/video/实测实量软硬件+电话.mp4') //url地址
      //     }],
      //     //poster: require('../../static/img/video/02.jpg'), // 封面地址
      //     // width: document.documentElement.clientWidth,
      //     notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      //     controlBar: {
      //         timeDivider: true,//当前时间和持续时间的分隔符
      //         durationDisplay: true,//显示持续时间
      //         remainingTimeDisplay: false,//是否显示剩余时间功能
      //         fullscreenToggle: true  //全屏按钮
      //     }
      // }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.autoplay, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.autoplay);
  },
  methods: {
    autoplay() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.playerOptions.autoplay = scrollTop > 340;
      this.playerOptions.muted = scrollTop > 340;
    },
  },
};
</script>

<style scoped>
.my-Video {
  width: 100%;
  background: #fff;
}

.my_video {
  width: 100%;
  background-color: white;
  margin: 0 auto;
  position: relative;
}

.video-js .vjs-big-play-button {
  /*对播放按钮的样式进行设置*/
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

/*通过添加样式object-fit:fill;来实现视频铺满*/
video {
  width: 100% !important;
  height: calc(100vh - 95px) !important;
  object-fit: fill; /*//消除留白*/
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue